<template>
  <div class="goltech-modal">
    <button class="goltech-modal__close" @click="$emit('exit-modal')">
      ✕
    </button>
    <iframe
      class="goltech-modal__iframe"
      :src="
        $store.getters['Setting/getSettings'].catalogUrl ||
        'https://heyzine.com/flip-book/07bbde8f91.html'
      "
      title="קטלוג"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "CatalogModal",
  emits: ["exit-modal"],
};
</script>

<style lang="scss" scoped>
.goltech-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 2000;
  display: flex;
  animation: goltech-slide-up 0.35s ease-out;

  &__iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  &__close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    color: #fff;
    font-size: 25px;
    cursor: pointer;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2001;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }

    &:focus {
      outline: none;
    }
  }
}

@keyframes goltech-slide-up {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
